/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import i18n from 'i18next';

import { UserDetailsRow } from '@/exceed';

import { Checkbox } from 'uikit/inputs';
import { Typo } from 'uikit/content';

import styles from '../styles/enrollmentsListContent.module.scss';

const EnrollmentsListContent = ({
  checkboxValue,
  item,
  onListItemCheckboxChange,
}) => {
  const { id, data } = item;

  const {
    course_version_number,
    first_name,
    last_name,
    position,
    code,
    formatted_enrolled_on,
    avatar_url,
    status,
  } = data;

  return (
    <div className={styles.element}>
      <div>
        <Checkbox
          className={styles.checkbox}
          value={checkboxValue}
          inputTestId={`enrollments-list-content-checkbox-${id}`}
          onChange={(value) => onListItemCheckboxChange({ value, id })}
        />
      </div>
      <UserDetailsRow
        avatarUrl={avatar_url}
        className={classnames(styles.column, styles.isGrower)}
        code={code}
        name={`${last_name}, ${first_name}`}
        position={position}
      />
      <Typo className={classnames(styles.column, styles.isFixed)} element="p" variant="s01">{formatted_enrolled_on}</Typo>
      <Typo className={classnames(styles.column, styles.isFixed)} element="p" variant="s01">{i18n.t(status)}</Typo>
      <Typo className={classnames(styles.column, styles.isFixed)} element="p" variant="s01">{course_version_number}</Typo>
      <div className={styles.columnEnd} />
    </div>
  );
};

EnrollmentsListContent.propTypes = {
  checkboxValue: PropTypes.bool,
  item: PropTypes.shape({
    id: PropTypes.number,
    data: PropTypes.shape({
      avatar_url: PropTypes.string,
      course_version_number: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string, // can be 'draft' or a number
      ]),
      code: PropTypes.string,
      first_name: PropTypes.string,
      formatted_enrolled_on: PropTypes.string,
      last_name: PropTypes.string,
      position: PropTypes.string,
      status: PropTypes.string,
    }),
  }).isRequired,
  onListItemCheckboxChange: PropTypes.func.isRequired,
};

EnrollmentsListContent.defaultProps = {
  checkboxValue: false,
};

export default React.memo(EnrollmentsListContent);
